import { PartnerType } from '@retailer-platform/dashboard/utils'
import { type DomainAccessControlConfig } from '../../../utils/domain/accessControl'
import { FeatureToggle } from '../../../access-control/featureToggles'

// Retailer-facing access is intentionally NOT permission-gated: every retailer
// is opted in by default. We scope the nav/route to retailer partners (the tool
// is meaningless for IDP/brand contexts), and per-tenant data isolation is
// enforced downstream by `retailerId` scoping at the service and mesh layers,
// not by RBAC.
//
// The `rt_enterprise_status_page_retailer` toggle is ANDed with the partner-type
// gate (both criteria in one object = AND) purely to keep the feature hidden in
// prod until release — the flag is enabled in dev/staging for testing. Once
// launched, this toggle can be dropped so the gate is partner-type-only.
export const enterpriseStatusPageRetailerAccessControl: DomainAccessControlConfig = [
  {
    partnerTypes: [PartnerType.Retailer],
    featureToggles: [FeatureToggle.rtEnterpriseStatusPageRetailer],
  },
]
